import { Address } from 'interfaces/Address.model';
import PmParcel from 'interfaces/PmParcel';
import countryMaps from '@pperform/pp-constants/countryCode';

type GetFromAddressDetails = (shipment?: PmParcel) => Address | null;

export const getFromAddressDetails: GetFromAddressDetails = (shipment) => {
  const fromAddress = shipment?.fromAddress;

  if (!fromAddress) {
    return null;
  }

  // Only return address details if both postalCode and countryCode exist and are not empty
  const { postalCode, countryCode } = fromAddress;

  return {
    countryCode: countryCode ?? '',
    postalCode: postalCode ?? '',
  };
};

// Locale-aware comparator for sorting translated labels; 'base' ignores case/accents
const collator = new Intl.Collator(undefined, { sensitivity: 'base' });

export const getCountryOptions = (
  t: (key: string) => string,
  countries: any[] = countryMaps,
) => {
  return countries
    .map((item) => {
      const label = t(`COUNTRY_CODE_${item.country_code}`);
      return { label, value: item.country_code };
    })
    .sort((a, b) => collator.compare(a.label, b.label));
};
